import { useEffect, useState } from 'react';
import { LOGOS } from '../logos';

const LOCAL_ASSETS = [
  'logo.png',
  'logo-head.jpg',
  'card-back.png',
  'icon-close.svg',
  'icon-volume-mute.svg',
  'icon-volume-on.svg',
  'icon-flash.svg',
  'icon-users.svg',
  'icon-users-nav.svg',
  'icon-dices.svg',
  'icon-categories.svg',
  'icon-suitcase.svg',
  'icon-transfer.svg',
  'icon-play.svg',
  'icon-controller.svg',
  'icon-document.svg',
  'icon-arrow-left.svg',
  'icon-timer.svg',
  'icon-user-solo.svg',
  'sticker-fail.webp',
  'sticker-win.webp',
];

const MIN_SHOW_MS = 1200;
const LEAVE_MS = 400;

function preload(url) {
  return new Promise((resolve) => {
    let settled = false;
    const done = () => {
      if (settled) return;
      settled = true;
      resolve();
    };
    const image = new Image();
    image.onload = done;
    image.onerror = done;
    image.src = url;
    setTimeout(done, 4000);
  });
}

function LoadingScreen({ onDone }) {
  const [progress, setProgress] = useState(0);
  const [leaving, setLeaving] = useState(false);

  useEffect(() => {
    const urls = [
      ...LOCAL_ASSETS.map((name) => `${process.env.PUBLIC_URL}/img/${name}`),
      ...LOGOS.map((logo) => logo.src),
    ];
    const startedAt = Date.now();
    let loaded = 0;
    let cancelled = false;

    urls.forEach((url) => {
      preload(url).then(() => {
        loaded += 1;
        if (!cancelled) setProgress(loaded / urls.length);
      });
    });

    Promise.all(urls.map(preload)).then(() => {
      const wait = Math.max(0, MIN_SHOW_MS - (Date.now() - startedAt));
      setTimeout(() => {
        if (cancelled) return;
        setLeaving(true);
        setTimeout(() => {
          if (!cancelled) onDone();
        }, LEAVE_MS);
      }, wait);
    });

    return () => {
      cancelled = true;
    };
  }, [onDone]);

  return (
    <div className={`loading${leaving ? ' leaving' : ''}`} aria-label="Загрузка">
      <img
        className="loading-logo"
        src={`${process.env.PUBLIC_URL}/img/logo.png`}
        alt="Tabys Games"
        draggable="false"
      />
      <div className="loading-track" role="progressbar" aria-valuemin={0} aria-valuemax={100}>
        <div
          className="loading-fill"
          style={{ transform: `scaleX(${Math.max(0.08, progress)})` }}
        />
      </div>
    </div>
  );
}

export default LoadingScreen;
